export const SET_BOOKING_LIST = 'SET_BOOKING_LIST';
export const SET_PHONE_NUMBER = 'SET_PHONE_NUMBER';
export const SET_TIMER = 'SET_TIMER';
export const SET_TIMER_INTERVER_ID = 'SET_TIMER_INTERVER_ID';
export const SET_IS_START_TIMER = 'SET_IS_START_TIMER';
export const SET_SKIP_BOOKING_AUTH = 'SET_SKIP_BOOKING_AUTH';
// export const SET_IS_VISIBLE_LOCATION_SERVICE_INFO = 'SET_IS_VISIBLE_LOCATION_SERVICE_INFO';
// export const SET_IS_VISIBLE_KEY_ISSUE_INFO = 'SET_IS_VISIBLE_KEY_ISSUE_INFO';